import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { BEGIN, FAILED, SUCCESSFUL } from '../../configs/actionNames';
import { APPLICATION_MODULE, INFORMATION_LOG_MODULE } from '../../configs/moduleNames';

export const LOAD_INFORMATION_LOG_LIST = '_LOAD_INFORMATION_LOG_LIST';
export const LOAD_INFORMATION_BY_ID = 'LOAD_INFORMATION_BY_ID';
export const CREATE_INFORMATION = '_CREATE_INFORMATION';

export const loadInformationLogList = createDeferredAction(INFORMATION_LOG_MODULE + LOAD_INFORMATION_LOG_LIST);
export const loadInformationLogListSuccessful = createAction(INFORMATION_LOG_MODULE + LOAD_INFORMATION_LOG_LIST + SUCCESSFUL);
export const loadInformationLogListFailed = createAction(INFORMATION_LOG_MODULE + LOAD_INFORMATION_LOG_LIST + FAILED);
export const loadInformationLogListBegin = createAction(INFORMATION_LOG_MODULE + LOAD_INFORMATION_LOG_LIST + BEGIN);

export const loadInformationById = createDeferredAction(INFORMATION_LOG_MODULE + LOAD_INFORMATION_BY_ID);
export const loadInformationByIdSuccessful = createAction(INFORMATION_LOG_MODULE + LOAD_INFORMATION_BY_ID + SUCCESSFUL);
export const loadInformationByIdFailed = createAction(INFORMATION_LOG_MODULE + LOAD_INFORMATION_BY_ID + FAILED);
export const loadInformationByIdBegin = createAction(INFORMATION_LOG_MODULE + LOAD_INFORMATION_BY_ID + BEGIN);

export const createInformation = createDeferredAction(INFORMATION_LOG_MODULE + CREATE_INFORMATION);
export const createInformationSuccessful = createAction(INFORMATION_LOG_MODULE + CREATE_INFORMATION + SUCCESSFUL);
export const createInformationFailed = createAction(INFORMATION_LOG_MODULE + CREATE_INFORMATION + FAILED);
